import React, {useState} from "react";

const CantidadCamas = (props) => {
    const { value } = props;

    const [cantidad, setCantidad] = useState(value);

    const handleChange = (e) => {
        setCantidad(e.target.value);
    }

    return (
        <input className="text-xs text-right appearance-none block w-20 bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
               type="number"
               step="any"
               value={cantidad}
               onChange={handleChange}
               name="cantidad"/>
    );
}

export default CantidadCamas;
